export default "__VITE_PUBLIC_ASSET__e4391ca8__"